import { Factory } from "@/data/dao/Factory";
import { CatalogDao } from "@/data/dao/service/CatalogDao";
import type { IFulfillmentGroup } from "@/data/model/FulfillmentGroup";
import { Format } from "@/data/util/Format";

import { BaseTabbedController } from "@/portal/controller/BaseTabbedController";
import { FulfillmentGroupForm } from "@/portal/forms/FulfillmentGroupForm";
import { TastierGlobal } from "@/portal/globalAccess";

export class FulfillmentGroupController extends BaseTabbedController<IFulfillmentGroup> {
    private groupForm: FulfillmentGroupForm;

    constructor(element: JQuery) {
        super(element, Factory.getInstance<CatalogDao>(CatalogDao).fulfillmentGroupDataSource);

        this.groupForm = new FulfillmentGroupForm(this.formContentByTabName("groupedit"));
        this.registerModelForm(this.groupForm);
    }

    protected onModelLoaded(m?: IFulfillmentGroup) {
        if (m === undefined) {
            const vw = $("#kt_header > #kt_header_menu_wrapper");
            if (vw.find("> .selectedlocation").length === 0)
                vw.append(
                    '<div class="selectedlocation">' +
                        Format.htmlEscape(TastierGlobal.getLocationSwitch()!.getCurrentLocationName()) +
                        "</div>"
                );
        }

        this.groupForm.setData(m);
    }
}
